"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GlyphRegistry = /** @class */ (function () {
    function GlyphRegistry(glyphs, language) {
        this.glyphs = [];
        this.language = 'de';
        this.glyphs = glyphs;
        this.language = language;
    }
    GlyphRegistry.prototype.get = function (letter) {
        var result;
        letter = this.replaceDiacritics(letter);
        for (var _i = 0, _a = this.glyphs; _i < _a.length; _i++) {
            var glyph = _a[_i];
            if (glyph.label !== letter) {
                continue;
            }
            else if (!result || result.count > glyph.count) {
                result = glyph;
            }
        }
        if (result) {
            result.count++;
        }
        return result;
    };
    GlyphRegistry.prototype.setDefaults = function (values) {
        values = typeof values === 'string' ? [values] : values;
        var result = [];
        for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
            var value = values_1[_i];
            for (var _a = 0, _b = this.glyphs; _a < _b.length; _a++) {
                var glyph = _b[_a];
                if (glyph.value === value) {
                    glyph.count++;
                    result.push(glyph);
                }
            }
        }
        return result;
    };
    GlyphRegistry.prototype.switch = function (oldValue, newValue) {
        var glyph = this.glyphs.find(function (glyph) { return glyph.value === newValue; });
        glyph.count++;
        this.release(oldValue);
    };
    GlyphRegistry.prototype.release = function (value) {
        var glyph = this.glyphs.find(function (glyph) { return glyph.value === value; });
        glyph.count--;
    };
    GlyphRegistry.prototype.replaceDiacritics = function (letter) {
        if ((letter.match(/[a-z \\-]/g) !== null) ||
            (this.language === 'da' && letter.match(/[åæø]/g) !== null) ||
            (this.language === 'de' && letter.match(/[äöü]/g) !== null) ||
            (this.language === 'fr' && letter.match(/[é]/g) !== null) ||
            (this.language === 'nb' && letter.match(/[åæø]/g) !== null) ||
            (this.language === 'sv' && letter.match(/[äåö]/g) !== null)) {
            return letter;
        }
        letter = letter.replace(/[àáâãäåąæ]/g, 'a');
        letter = letter.replace(/[ćç]/g, 'c');
        letter = letter.replace(/[èéêëę]/g, 'e');
        letter = letter.replace(/[ìíîï]/g, 'i');
        letter = letter.replace(/[ł]/g, 'l');
        letter = letter.replace(/[ńñ]/g, 'n');
        letter = letter.replace(/[òóôõöøœ]/g, 'o');
        letter = letter.replace(/[śß]/g, 's');
        letter = letter.replace(/[ùúûü]/g, 'u');
        letter = letter.replace(/[ÿ]/g, 'y');
        letter = letter.replace(/[źż]/g, 'z');
        return letter;
    };
    return GlyphRegistry;
}());
var GlyphMatcher = /** @class */ (function () {
    function GlyphMatcher(config) {
        this.config = config;
        this.glyphs = [];
        this.assignedGlyphsCollection = [];
        if (this.config.configJson.hasOwnProperty('glyphs')) {
            for (var _i = 0, _a = this.config.configJson.glyphs.options; _i < _a.length; _i++) {
                var glyph = _a[_i];
                if (glyph.value) {
                    this.glyphs.push({
                        value: glyph.value,
                        label: glyph.label,
                        image: glyph.image,
                        zoom: { scale: 2, x: glyph.zoom === 'right' ? 1 : 0, y: .9 },
                        count: 0,
                        alternatives: this.countAlternatives(glyph.label)
                    });
                }
            }
        }
        this.registry = new GlyphRegistry(this.glyphs, this.config.params.langBook);
    }
    GlyphMatcher.prototype.getGlyphDetails = function (value) {
        return this.glyphs.find(function (glyph) { return glyph.value === value; });
    };
    GlyphMatcher.prototype.countAlternatives = function (label) {
        var count = -1;
        for (var _i = 0, _a = this.config.configJson.glyphs.options; _i < _a.length; _i++) {
            var glyph = _a[_i];
            if (glyph.value && glyph.label === label) {
                count++;
            }
        }
        return count;
    };
    GlyphMatcher.prototype.update = function (prefix, id, letters) {
        if (!this.assignedGlyphsCollection.find(function (e) { return e.id === prefix + "." + id; })) {
            this.assignedGlyphsCollection.push({
                id: prefix + "." + id,
                letters: letters,
                glyphs: this.registry.setDefaults(this.config.defaults["" + prefix][id + "_abc"].slice())
            });
        }
        var collection = this.assignedGlyphsCollection.find(function (e) { return e.id === prefix + "." + id; });
        var assignedGlyphs = collection.glyphs;
        var countBeg = 0;
        var countEnd = 0;
        var completeLetters = letters;
        letters = letters.toLowerCase();
        // count consistent letters from beginning
        for (var i = 0; i < letters.length; i++) {
            if (assignedGlyphs.length > i) {
                if (assignedGlyphs[i].label !== letters[i]) {
                    break;
                }
                countBeg++;
            }
        }
        // save consistent glyphs from beginning and slice letters
        var arrayBeg = assignedGlyphs.splice(0, countBeg);
        letters = letters.slice(countBeg);
        // count consistent letters from end
        var offset = letters.length - assignedGlyphs.length;
        for (var i = assignedGlyphs.length - 1; i >= 0; i--) {
            if (assignedGlyphs[i].label !== letters[i + offset]) {
                break;
            }
            countEnd++;
        }
        // save consistent glyphs from beginning and slice letters
        var arrayEnd = countEnd > 0 ? assignedGlyphs.splice(-countEnd) : [];
        letters = letters.slice(0, letters.length - countEnd);
        // remove remaining glyphs
        while (assignedGlyphs.length) {
            this.registry.release(assignedGlyphs.pop().value);
        }
        // add missing glyphs
        var arrayNew = [];
        for (var _i = 0, letters_1 = letters; _i < letters_1.length; _i++) {
            var letter = letters_1[_i];
            var glyph = this.registry.get(letter);
            if (!glyph) {
                continue;
            }
            arrayNew.push(Object.assign({}, glyph));
        }
        // save all that new stuff in collection
        assignedGlyphs = assignedGlyphs.concat(arrayBeg, arrayNew, arrayEnd);
        collection.glyphs = assignedGlyphs;
        collection.letters = completeLetters;
    };
    GlyphMatcher.prototype.getLetters = function (prefix, id) {
        if (!this.assignedGlyphsCollection.find(function (e) { return e.id === prefix + "." + id; })) {
            this.assignedGlyphsCollection.push({ id: prefix + "." + id, letters: '', glyphs: [] });
        }
        var letters = this.assignedGlyphsCollection.find(function (e) { return e.id === prefix + "." + id; }).letters;
        return letters;
    };
    GlyphMatcher.prototype.getGlyphs = function (prefix, id) {
        if (!this.assignedGlyphsCollection.find(function (e) { return e.id === prefix + "." + id; })) {
            this.assignedGlyphsCollection.push({ id: prefix + "." + id, letters: '', glyphs: [] });
        }
        var assignedGlyphs = this.assignedGlyphsCollection.find(function (e) { return e.id === prefix + "." + id; }).glyphs;
        return assignedGlyphs;
    };
    GlyphMatcher.prototype.switchGlyph = function (prefix, id, index) {
        var assignedGlyphs = this.getGlyphs(prefix, id);
        var oldGlyph = assignedGlyphs[index];
        var newGlyph;
        var glyphs = [];
        var glyphIndex;
        for (var _i = 0, _a = this.glyphs; _i < _a.length; _i++) {
            var glyph = _a[_i];
            if (glyph.label === oldGlyph.label) {
                glyphs.push(glyph);
            }
        }
        glyphIndex = glyphs.findIndex(function (glyphIndex) { return glyphIndex.value === oldGlyph.value; });
        glyphIndex++;
        glyphIndex %= glyphs.length;
        newGlyph = glyphs[glyphIndex];
        assignedGlyphs[index] = Object.assign({}, newGlyph);
        this.registry.switch(oldGlyph.value, newGlyph.value);
        this.assignedGlyphsCollection.find(function (e) { return e.id === prefix + "." + id; }).glyphs = assignedGlyphs;
    };
    return GlyphMatcher;
}());
exports.default = angular.module('pb.glyphMatcher', [])
    .service('glyphMatcher', GlyphMatcher);
